import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Form from "react-jsonschema-form";
import $ from 'jquery'
import { findSubscription, setSubscription } from '../../../view/inicio/acoes/MySubscriptionsActions';
import { build, opcoesSemVagas } from '../helps/Builder';
import LableFormInfo from '../../elements/LableFormInfo'
import { View, Progress } from 'react-template'
import "../../../assets/css/components/formbuilder/container/formContainer.css"
import {
    buscarFormularioAtivo, buscarFormularioAtivoInterno, enviarSubmissao, uploadArquivo,
    enviarReSubmissao, enviarSubmissaoInterna, enviarReSubmissaoInterna, buscarSubmissoesPorCPF,
    buscarDadosInscricaoPorCPFETipo, verificaResubmissao, apagarArquivosSubmissao, buscaCEP, consultaCEP}
    from '../../../view/formulario/actions/FormActions';

const options = [{ value: 'PROFESSOR', text: 'Professor' },
{ value: 'ALUNO', text: 'Aluno' },
{ value: 'LIVRE', text: 'Externo' },];

class FormContainer extends View {
    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.consultarInscricoes = this.consultarInscricoes.bind(this);
        this.submeterArquivos = this.submeterArquivos.bind(this);
        this.formularioExiste = false;
        this.confirm = false;

        //ressubmissao
        this.dataResubmissao = null;
        this.cpfRessubmissao = null;
        this.idSubmissao = null;
        this.caminhosUpload = [];

        this.statusLoader = false;
        this.state = {
            permissao: '',
            schema: {},
            uiSchema: {},
            formData: {},
            formEditavel: {},
            certificado: false,
            valorInscricao: 0,
            limiteDeInscritos: 0,
            identificadorMunicipio: '',
        }
        this.liveValidate = false
        this.cepPreenchido = false;
    }

    setAttrInputFile() {
        $('.form-builder-layout input[type=file]').attr("accept", "application/pdf");
    }

    setPermissaoCamposIniciais(permissao) {
        let idEvento = this.getIdEvento();
        const that = this;
        $(function () {
            // Desabilitando inputs
            $('.form-builder-layout input, .form-builder-layout select, .form-builder-layout textarea, .form-builder-layout button[type=submit]').prop("disabled", true);
            $('.form-builder-layout input, .form-builder-layout select, .form-builder-layout textarea, .form-builder-layout button[type=submit]').addClass('disable');
            $('input[label=CPF]').attr("disabled", false);
            $('input[label=CPF]').removeClass('disable');
            $('input[label=CPF]').focus();

            if (that.temEvento()) {
                $(`select[id=root_questao_${idEvento}]`).attr("disabled", false);
                $(`select[id=root_questao_${idEvento}]`).removeClass('disable');
            }

            // Desabilidanto campo Nome quando não for livre
            if (permissao !== 'LIVRE') {
                $('input[label=Nome]').attr("disabled", true);
                $('input[label=Nome]').attr("title", "Não é permitido alterar o valor do Campo Nome.");
            }
        })
    }

    liberarCamposFormulario(permissao) {
        $(function () {
            $('.form-builder-layout input, .form-builder-layout select, .form-builder-layout textarea, .form-builder-layout button[type=submit]').prop("disabled", false);
            $('.form-builder-layout input, .form-builder-layout select, .form-builder-layout textarea, .form-builder-layout button[type=submit]').removeClass('disable');

            if (permissao !== 'LIVRE') {
                $(function () {
                    $('input[label=Nome]').attr("disabled", true);
                    $('input[label=Nome]').attr("title", "Não é permitido alterar o valor do Campo Nome.");
                })
            }
        })
    }

    liberarCamposEndereco(liberaCampos) {
        $(function () {
            for (let i = 4; i <= 7; i = i + 3) {
                $('input[id=root_questao_' + i + ']').prop("disabled", !liberaCampos)
                liberaCampos ? $('input[id=root_questao_' + i + ']').removeClass('disable') :
                    $('input[id=root_questao_' + i + ']').addClass('disable');
            }
        })
    }

    changeSubmitStatus(bool) {
        $(function () {
            $('.form-builder-layout input, .form-builder-layout select, .form-builder-layout textarea, .form-builder-layout button[type=submit]').prop("disabled", bool);
            if (bool) {
                $('.form-builder-layout input, .form-builder-layout select, .form-builder-layout textarea, .form-builder-layout button[type=submit]').addClass('disable');
            } else {
                $('.form-builder-layout input, .form-builder-layout select, .form-builder-layout textarea, .form-builder-layout button[type=submit]').removeClass('disable');
            }
        })
    }

    componentDidUpdate() {
        this.setAttrInputFile();
        let permissao = this.state.permissao;
        let formData = this.state.formData;
        if (!(formData.questao_0 && formData.questao_0.length === 14)) {
            this.setPermissaoCamposIniciais(permissao)
        }
    }

    componentDidMount() {


        if (this.props.idForm === undefined) {
            this.setState({ schema: this.props.schema, uiSchema: this.props.uiSchema });
            this.formularioExiste = true;
            this.forceUpdate();
        } else {
            if (this.props.interno) {
                buscarFormularioAtivoInterno(this.props.idForm, this.resBuscarFormulario.bind(this), this.errorBuscarFormulario.bind(this));
            } else {
                buscarFormularioAtivo(this.props.idForm, this.resBuscarFormulario.bind(this), this.errorBuscarFormulario.bind(this));
            }
        }
    }

    resBuscarFormulario(res) {
        let formEditavel = res.data.formEditavel;
        let formEditavel_json = JSON.parse(formEditavel);
        let form = build(formEditavel_json.itens, formEditavel_json.titulo, formEditavel_json.descricao); //res.data.formSchema;
        let certificado = res.data.certificado;
        let valorInscricao = res.data.valorBoleto;
        let limiteDeInscritos = res.data.limiteDeInscritos;
        this.setState({
            ...this.state,
            schema: form.schema,
            uiSchema: form.uiSchema,
            permissao: res.data.permissao,
            formEditavel: formEditavel_json,
            valorBoleto: valorInscricao,
            certificado,
            valorInscricao,
            limiteDeInscritos,
        });

        this.setPermissaoCamposIniciais(res.data.permissao);
        if (res.data.status) { //formulario disponível
            this.formularioExiste = true;
            this.forceUpdate();
        } else {
            this.formularioExiste = null;
            this.setState({ schema: null, uiSchema: null });
        }
        $("#progressBuscaCPF").addClass("d-none")
    }

    errorBuscarFormulario() {
        this.notifyError('Erro ao buscar Formulário', '');
        this.formularioExiste = null;
        this.setState({ schema: null, uiSchema: null });
        $("#progressBuscaCPF").addClass("d-none")
    }



    // validador de CPF
    TestaCPF(cpf) {
        const strCPF = cpf.replace(/[.-]/g, "");
        let Soma;
        let Resto;
        Soma = 0;
        if (strCPF === "00000000000" || strCPF === "11111111111" ||
            strCPF === "22222222222" || strCPF === "33333333333" ||
            strCPF === "44444444444" || strCPF === "55555555555" ||
            strCPF === "66666666666" || strCPF === "77777777777" ||
            strCPF === "88888888888" || strCPF === "99999999999")
            return false;
        for (var i = 1; i <= 9; i++) {
            Soma += parseInt(strCPF.substring(i - 1, i), 10) * (11 - i);
        }
        Resto = (Soma * 10) % 11;
        if ((Resto === 10) || (Resto === 11)) Resto = 0;
        if (Resto !== parseInt(strCPF.substring(9, 10), 10)) return false;
        Soma = 0;
        for (i = 1; i <= 10; i++) Soma += parseInt(strCPF.substring(i - 1, i), 10) * (12 - i);
        Resto = (Soma * 10) % 11;
        if ((Resto === 10) || (Resto === 11)) Resto = 0;
        if (Resto !== parseInt(strCPF.substring(10, 11), 10)) return false;
        return true;
    }

    onChange(form) {
        if (form.errors.length > 0) {
            this.liveValidate = true
        }
        if (this.props.idForm !== undefined) {
            let permissao = this.state.permissao
            if (this.temEvento()) {
                const idEvento = this.getIdEvento();
                const textoPermissao = form.formData[`questao_${idEvento}`];
                if (textoPermissao !== undefined) {
                    permissao = this.getPermissao(textoPermissao.split(' ')[0]);
                    this.setState({ ...this.state, permissao: permissao });
                }
            }
            if (form.formData.questao_0 && form.formData.questao_0.length === 14) {
                this.setDadosRH(form, permissao);
                this.setValorBoleto(form);
                this.onChangeCep(form)
            } else {
                // if(this.state.formData.questao_0){
                //     this.setState({formData: {}});
                // }
                // setando campos iniciais novamente
                this.setPermissaoCamposIniciais(permissao)
            }
        } else if (form.formData.questao_0 && form.formData.questao_0.length === 14) {
            this.liberarCamposFormulario('LIVRE');
        }
    }

    onChangeCep(form) {
        if (this.temBoleto()) {
            let cep = form.formData.questao_3
            if (cep !== undefined && cep.length === 9) {
                this.liberarCamposEndereco(false)
                if (!this.cepPreenchido) {
                    consultaCEP(
                        cep,
                        endereco => {
                          if (endereco) {
                            this.setState({ uf: endereco.uf, cidade: endereco.cidade });
                            this.preencheValoresEndereco(endereco, form);
                            this.cepPreenchido = true;
                            this.liberarCamposEndereco(true);
                          } else {
                            this.liberarCamposEndereco(false);
                            this.notifyWarning("Não foi possível buscar o CEP informado");
                          }
                        },
                        error => {
                          buscaCEP(cep, res => {
                            if (res) {
                              let endereco = {};
                              endereco["cep"] = res.data.cep;
                              endereco["logradouro"] = res.data.logradouro;
                              endereco["complemento"] = res.data.complemento;
                              endereco["bairro"] = res.data.bairro;
                              endereco["numero"] = form.formData.questao_7;
                              this.setState({ uf: res.data.uf, cidade: res.data.localidade });
                              this.preencheValoresEndereco(endereco, form);
                              this.cepPreenchido = true;
                              this.liberarCamposEndereco(true);
                            } else {
                              this.liberarCamposEndereco(false);
                              this.notifyWarning("Não foi possível buscar o CEP informado");
                            }
              
                          }, error => {
                            this.notifyWarning("Não foi possivel consultar os serviços de confirmação de CEP, tente novamente mais tarde");
                          })
              
                        });
                }
            } else {
                this.cepPreenchido = false;
                this.liberarCamposEndereco(false)
            }
        }
    }

    preencheValoresEndereco(endereco, form) {
        $(function () {

            if (!endereco.logradouro || /^\s*$/.test(endereco.logradouro)) {
                form.formData.questao_4 = "S/N";
                $('input[id=root_questao_4]').val("S/N")
                $('input[id=root_questao_4]').attr('value', "S/N")
            } else {
                form.formData.questao_4 = endereco.logradouro;
                $('input[id=root_questao_4]').val(endereco.logradouro)
                $('input[id=root_questao_4]').attr('value', endereco.logradouro)
            }
            $('input[id=root_questao_5]').val(endereco.complemento);
            $('input[id=root_questao_5]').attr('value', endereco.complemento);
            form.formData.questao_5 = endereco.complemento
            $('input[id=root_questao_6]').val(endereco.numero);
            $('input[id=root_questao_6]').attr('value', endereco.numero);
            form.formData.questao_6 = endereco.numero
            if (!endereco.bairro || /^\s*$/.test(endereco.bairro)) {
                form.formData.questao_7 = "S/N";
                $('input[id=root_questao_7]').val("S/N")
                $('input[id=root_questao_7]').attr('value', "S/N")
            } else {
                form.formData.questao_7 = endereco.bairro;
                $('input[id=root_questao_7]').val(endereco.bairro)
                $('input[id=root_questao_7]').attr('value', endereco.bairro)
            }
        })
    }

    setDadosRH(form, permissao) {
        if (this.TestaCPF(form.formData.questao_0)) {

            const cpf = form.formData.questao_0;
            if (permissao !== 'LIVRE' && (!this.state.formData.questao_0 || cpf !== this.state.formData.questao_0)) {
                // Pesquisa o CPF no HR para trazer os dados do sistema 
                // e verifica se ele se enquadra na permissão
                this.setPermissaoCamposIniciais(permissao);
                $("#progressBuscaCPF").removeClass("d-none")
                buscarDadosInscricaoPorCPFETipo(cpf, permissao, res => {
                    const status = res.status;
                    if (status === 200) {
                        this.liberarCamposFormulario(permissao);
                        // Atualiza o input de nome com o nome vinculado ao CPF
                        $('input[label=Nome]').val(res.data.nome);
                        // Atualiza o valor do formData do formBuilder
                        const formData = form.formData;
                        formData.questao_0 = cpf;
                        formData.questao_1 = res.data.nome;
                        // Atualiza o estado
                        this.setState({
                            ...this.state,
                            formData: formData
                        });
                    }
                    $("#progressBuscaCPF").addClass("d-none")
                },
                    error => {
                        const status = error.response.status
                        if (status === 404) {
                            // mensagem de erro quando o cpf não tem a permissão
                            this.getMessages(permissao);
                            this.setPermissaoCamposIniciais(permissao);
                        } else {
                            // mensagem quando ocorre um erro na busca
                            this.notifyError(error.data, "");
                        }
                        $("#progressBuscaCPF").addClass("d-none")
                    })
            } else {
                this.liberarCamposFormulario(permissao);
            }
        } else {
            this.notifyWarning("CPF Inválido!", "");
            this.setPermissaoCamposIniciais(permissao)
        }
    }

    getMessages(permissao) {
        if (permissao === 'ALUNO') {
            this.notifyWarning("Este CPF não pertence a um Aluno regularmente matriculado na UEPB", "");
        } else if (permissao === 'PROFESSOR') {
            this.notifyWarning("Este CPF não pertence a um Professor regularmente vinculado à UEPB", "");
        } else if (permissao === 'TECNICO') {
            this.notifyWarning("Este CPF não pertence a um Técnico regularmente vinculado à UEPB", "");
        } else if (permissao === 'SERVIDOR') {
            this.notifyWarning("Este CPF não pertence a um Servidor regularmente vinculado à UEPB", "");
        } else if (permissao === 'CHEFE') {
            this.notifyWarning("Este CPF não pertence a um Chefe ou Chefe adjunto de seto vinculado a UEPB", "");
        } else if (permissao === 'ACADEMICO') {
            this.notifyWarning("Este CPF não pertence a um Acadêmico regularmente vinculado à UEPB", "");
        }
    }

    setValorBoleto(form) {
        const formData = form.formData;
        //verifica se o formulario gera boleto
        if (this.temBoleto()) {
            let valorBoleto = this.getValorDecimal(this.state.formEditavel.valorBoleto);
            this.state.formEditavel.itens.forEach(item => {
                //verifica as questoes que agregam valor
                if ((item.tipo === 'select' || item.tipo === 'radio' || item.tipo === 'checkbox') && (item.opcoes[0].valor !== undefined)) {
                    //verrifica se a questao foi selecionada
                    const opcaoSelecionada = formData['questao_' + item.id];
                    if (opcaoSelecionada !== undefined) {
                        let opcaoForm = [];
                        if (item.tipo === 'checkbox') {
                            opcaoForm = item.opcoes.filter(opcao => {
                                let selecionou = false;
                                opcaoSelecionada.forEach(check => {
                                    if (this.getStringTextoComValor(opcao) === check) {
                                        selecionou = true;
                                    }
                                });
                                return selecionou;
                            });
                        } else {
                            opcaoForm = item.opcoes.filter(opcao => this.getStringTextoComValor(opcao) === opcaoSelecionada);
                        }
                        opcaoForm.map(opcao => valorBoleto += this.getValorDecimal(opcao.valor));
                        valorBoleto = Math.round(valorBoleto * 100) / 100;
                    }
                }
            });
            this.setState({ ...this.state, valorBoleto: valorBoleto, formData: formData });
        }
    }

    getValorDecimal(valorBoleto) {
        let inicio = '';
        let fim = '';
        if (valorBoleto.length > 3) {
            inicio = valorBoleto.slice(0, valorBoleto.length - 3);
            fim = valorBoleto.slice(valorBoleto.length - 3);
            inicio = inicio.replace('.', '');
            fim = fim.replace(',', '.');
        } else {
            inicio = valorBoleto.slice(0);
        }
        let novoValor = inicio + fim;
        return parseFloat(novoValor);
    }

    getStringTextoComValor(opcao) {
        let valor = '';
        let vagas = '';
        if (opcao.valor !== undefined) {
            valor = ' - R$' + opcao.valor
        }
        if (opcao.limiteDeVagas !== undefined) {
            vagas = ' - Vagas: ' + opcao.limiteDeVagas;
        }
        return opcao.texto + valor + vagas;
    }

    getIdEvento() {
        return this.state.formEditavel.evento;
    }
    temEvento() {
        return (this.state.formEditavel.evento > 0);
    }

    getPermissao(textoPermissao) {
        return options.filter(option => (
            option.text === textoPermissao
        ))[0].value;
    }

    onSubmit(form) {
        if (this.props.idForm !== undefined) {
            this.changeLoaderStatus();
            const idForm = this.props.idForm;
            const cpf = form.formData.questao_0;
            this.changeSubmitStatus(true)
            verificaResubmissao(idForm, cpf, res => {
                const status = res.status;
                if (status === 200) {
                    const idSubmissao = res.data
                    if (this.state.formEditavel.resubmissao) { // já tem submissao nesse formulário, mas é permitido ressubmissão
                        this.submeter(form, idSubmissao)
                    } else { // já tem submissao nesse formulário e não é permitido ressubmissão
                        this.changeLoaderStatus();
                        this.changeSubmitStatus(false)
                        this.notifyWarning("CPF já cadastrado neste formulário.", "Consulte suas inscrições.");
                    }
                } else if (status === 204) { // não tem submissao para o formulário
                    this.submeter(form, 0);
                }
            }, error => {
                this.changeLoaderStatus();
                this.notifyError("Erro ao tentar realizar inscrição!", error);
                this.changeSubmitStatus(false)
            });
            this.setState({ ...this.state, formData: form.formData });
        }
    }

    submeter(form, idSubmissao) {
        let { idForm, cpf, caminhosUpload, data } = this.carregaDadosSubmissao(form);
        if (idSubmissao > 0) { // ressubmissao
            this.dataResubmissao = data;
            this.idSubmissao = idSubmissao
            this.cpfRessubmissao = cpf;
            this.caminhosUpload = caminhosUpload
            this.confirm = true;
            this.forceUpdate();
        } else { //submissao
            this.submeterArquivos(caminhosUpload, idForm, cpf, data, idSubmissao);
        }
    }

    submeterArquivos(caminhosUpload, idForm, cpf, data, idSubmissao) {
        let numUploads = caminhosUpload.length;
        if (numUploads === 0) {
            this.submeterFormulario(idForm, cpf, data, idSubmissao);
        }
        else {
            const arquivo = caminhosUpload.pop().arquivo;
            uploadArquivo(arquivo, idForm, cpf,
                res => {
                    this.submeterArquivos(caminhosUpload, idForm, cpf, data, idSubmissao);
                }, error => {
                    this.changeSubmitStatus(false)
                    this.changeLoaderStatus();
                    this.notifyError("Erro ao realiazar inscrição", "Tente novamente.")
                });
        }
    }

    submeterFormulario(idForm, cpf, data, idSubmissao) {
        if (idSubmissao === 0) {
            if (this.props.interno) {
                enviarSubmissaoInterna(idForm, data, res => this.formularioRes(cpf), error => this.formularioError(idForm, cpf, error));
            } else {
                enviarSubmissao(idForm, data, res => this.formularioRes(cpf), error => this.formularioError(idForm, cpf, error));
            }
        } else {
            if (this.props.interno) {
                enviarReSubmissaoInterna(idSubmissao, idForm, data, res => this.formularioRes(cpf), error => this.formularioError(idForm, cpf, error));
            } else {
                enviarReSubmissao(idSubmissao, idForm, data, res => this.formularioRes(cpf), error => this.formularioError(idForm, cpf, error));
            }
        }
    }

    formularioRes(cpf) {
        this.changeLoaderStatus();
        this.props.findSubscription(cpf);
        this.notifySucess("Sucesso", "Incrição Realizada!");
        if (this.props.interno) {
            this.redirect(`/admin/inscricoes-internas?idForm=${this.props.idForm}&cpf=${cpf}`);
        } else {
            this.consultarInscricoes(cpf);
        }
    }

    formularioError(idForm, cpf, error) {
        apagarArquivosSubmissao(idForm, cpf, res => { }, error => { });
        const status = error.response.status;
        this.changeSubmitStatus(false)
        this.changeLoaderStatus();
        switch (status) {
            case 406:
                this.notifyWarning("Inscrição não realizada", error.response.data);
                break;
            case 409:
                this.notifyWarning("Inscrição não realizada", error.response.data);
                break;
            default:
                this.notifyError("Erro ao tentar realizar inscrição!", "Tente novamente.");
                break;
        }
    }

    carregaDadosSubmissao(form) {
        const idForm = this.props.idForm;
        const cpf = form.formData.questao_0;
        const nome = form.formData.questao_1;
        let formData = form.formData
        let cpfOk = (form.formData.questao_0 !== undefined ? form.formData.questao_0.length === 14 : false);
        let caminhosUpload = [];
        let endereco = this.carregaDadosEndereco(form)
        for (let itemName in form.schema.properties) {
            const item = form.schema.properties[itemName];
            if (item.format === 'data-url' && cpfOk && form.formData[itemName] !== undefined) {
                let arquivo = new FormData();
                const arquivoData = document.getElementById('root_' + itemName).files[0]
                arquivo.append('file', arquivoData, arquivoData.name.replace(/[^A-Za-z0-9.]/g, ""));
                const caminho = arquivoData.name;
                caminhosUpload.push({ questao: itemName, caminho: caminho, arquivo: arquivo });
            }
        }
        caminhosUpload.forEach(item => {
            formData[item.questao] = item.caminho;
        });
        // removendo a informação de numero de vagas das opções com limite de vagas
        let opSemVagas = opcoesSemVagas(this.state.formEditavel.itens);
        if (opSemVagas.length > 0) Object.keys(formData).forEach(key => {

            if (formData[key] && opSemVagas[key]) {
                if (opSemVagas[key].opcoes) {
                    opSemVagas[key].opcoes.find(op => {
                        if (formData[key] === op.comVagas) {
                            formData[key] = op.semVagas;
                        }
                    })
                } else if (opSemVagas[key].items.opcoes) {
                    opSemVagas[key].items.opcoes.find(op => {
                        if (formData[key] === op.comVagas) {
                            formData[key] = op.semVagas;
                        }
                    })
                }
            }
        })
        let dadosForm = JSON.stringify(formData);
        const data = {
            cpf: cpf,
            nome: nome,
            cep: endereco.cep,
            logradouro: endereco.logradouro,
            complemento: endereco.complemento,
            numero: endereco.numero,
            bairro: endereco.bairro,
            identificadorMunicipio: endereco.identificadorMunicipio,
            dadosForm: dadosForm,
            valorBoleto: this.state.valorBoleto
        };
        let numUploads = caminhosUpload.length;
        return { idForm, cpf, numUploads, caminhosUpload, data };
    }

    carregaDadosEndereco(form) {
        let cep = form.formData.questao_3
        let logradouro = form.formData.questao_4
        let complemento = form.formData.questao_5
        let numero = form.formData.questao_6
        let bairro = form.formData.questao_7
        let identificadorMunicipio = this.state.identificadorMunicipio
        return { cep, logradouro, complemento, numero, bairro, identificadorMunicipio }
    }

    consultarInscricoes(cpf) {
        buscarSubmissoesPorCPF(cpf,
            res => {
                const submissoes = res.data.content;
                if (submissoes.length > 0) {
                    this.props.setSubscription(res.data.content);
                    this.redirect('/inscricoes');
                }
            }, error => {
                this.notifyError("Erro ao consultar Inscricao", "");
                this.redirect('/inscricoes');
            }
        );
    }

    transformErrors(errors) {
        // Mudando titulo do panel de erro
        $(function () {
            $('.form-builder-layout .errors h3').text('Ops! Erros encontrados.')
        })

        const errorMessengerList = {
            "required": `Campo obrigatório precisa ser preenchido: `,
            "email": 'Campo de E-mail com informação invalida',
            "date": 'Data Inválida',
            "number": 'Formato de número invalido.',
            "enum": 'Nenhuma opção válida selecionada.',
        }

        return errors.map(error => {
            if (error.name === "required") {
                error.message = errorMessengerList.required + error.schema.properties[error.argument].title;
                error.stack = errorMessengerList.required + error.schema.properties[error.argument].title
            } else if (error.name === "format" && error.argument === "email") {
                error.message = errorMessengerList.email;
                error.stack = errorMessengerList.email + ": " + error.schema.title
            } else if (error.name === "format" && error.argument === "date") {
                error.message = errorMessengerList.date
                error.stack = errorMessengerList.date + ": " + error.schema.title
            } else if (error.name === "type" && error.schema.type === "number") {
                error.message = errorMessengerList.number
                error.stack = errorMessengerList.number + ": " + error.schema.title
            } else if (error.name === "enum") {
                error.message = errorMessengerList.enum
                error.stack = errorMessengerList.enum
            }
            return error;
        });
    }

    infoDoFormulario() {
        return (
            <div>
                <LableFormInfo
                    certificado={this.state.certificado}
                    valor={this.state.valorInscricao}
                    n_vagas={this.state.limiteDeInscritos}
                    permissao={this.state.permissao}>
                </LableFormInfo>
            </div>
        )
    }

    temBoleto() {
        return this.props.idForm !== undefined && this.state.formEditavel.dataLimiteBoleto.length > 0;
    }

    temResubmissao() {
        return this.props.idForm !== undefined && !this.state.formEditavel.resubmissao;
    }

    changeLoaderStatus() {
        this.statusLoader = !this.statusLoader;
        this.forceUpdate();
    }

    mostrarModal() {
        this.displayModal('Você ja se inscreveu nesse formulário', '', 'Quer atualizar os dados da inscrição?',
            this.ressubmeterFormulario.bind(this),
            this.onCancelModal.bind(this));
    }

    ressubmeterFormulario() {
        this.confirm = false;
        this.submeterArquivos(this.caminhosUpload, this.props.idForm, this.cpfRessubmissao, this.dataResubmissao, this.idSubmissao);
    }

    onCancelModal() {
        this.confirm = false;
        this.changeLoaderStatus();
        this.changeSubmitStatus(false)
    }

    render() {
        return (
            <div>
                <div className='box form-builder-layout p-r form-answer'>
                    {this.formularioExiste ? (
                        <div>
                            {<Progress id='progressBuscaCPF' position={'top'} />}
                            {this.statusLoader && <Progress position={'bottom'} />}
                            <div className='form-info'>
                                <section>{this.state.schema.title}</section>
                                {this.infoDoFormulario()}
                                <p>{this.state.schema.description}</p>
                                {this.temBoleto() && <p>Valor da inscrição: R${this.state.formEditavel.valorBoleto}</p>}
                            </div>
                            <Form
                                schema={this.state.schema}
                                uiSchema={this.state.uiSchema}
                                onSubmit={this.onSubmit}
                                onChange={this.onChange}
                                formData={this.state.formData}
                                transformErrors={this.transformErrors}
                                showErrorList={false}
                                liveValidate={this.liveValidate}
                            >
                                <div>
                                    {this.temBoleto() && <p>Total à pagar: R${this.state.valorBoleto}</p>}
                                    <button className='btn btn-primary' type="submit">Enviar</button>
                                    {this.confirm && this.mostrarModal()}
                                    <div className="p-t">
                                        {this.temResubmissao() && <div >Esse formulário não permite ressubmissão. *</div>}
                                        {this.state.formEditavel.confirmarPorEmail && <div >Esse formulário requer <b>confirmação por email</b> após período de inscrição. *</div>}
                                    </div>
                                </div>
                            </Form>
                        </div>
                    ) : (
                            this.formularioExiste === null && (
                                <div>
                                    <h4>O Formulário não está disponível ou não existe</h4>
                                </div>
                            )
                        )}
                </div>
            </div>
        );
    }
}

FormContainer.propTypes = {
    idForm: PropTypes.string,
    schema: PropTypes.object,
    uiSchema: PropTypes.object
};

const mapDispatchToProps = (dispatch) => (
    bindActionCreators({ findSubscription, setSubscription }, dispatch)
);

export default connect(null, mapDispatchToProps)(FormContainer);


// WEBPACK FOOTER //
// ./src/components/formbuilder/container/FormContainer.js